import angular from 'angular';
import gettext from 'angular-gettext';
import toastr from 'angular-toastr';
import UserResource from '../../cmsCore/UsersModules/UserResource'

let usersPageAddModule = angular.module('cms.users.add', [UserResource, gettext, toastr])
    .component('appUsersAdd', {
        template: require('./templates/usersAdd.html'),
        controller: function (UserResource, $state, toastr, gettextCatalog, $stateParams, SaveWarning) {

            /** @ngInject */

            this.user = {
                language: 'en'
            };
            this.errors = {};
            this.successAdd = false;

            SaveWarning.watch({}, this.user);

            function goToReturnState() {
                SaveWarning.stopWatch();
                if ($stateParams.returnState) {
                    $state.go($stateParams.returnState.name, $stateParams.returnState.params)
                } else {
                    $state.go('users', {})
                }
            }

            this.add =  () => {
                UserResource.save(this.user,
                    response => {
                        this.user = {};
                        this.errors = {};
                        this.successAdd = true;
                        toastr.success(
                            gettextCatalog.getString( 'User {{username}} created!', {username: this.user.username}),
                            gettextCatalog.getString('Success')
                        );

                        goToReturnState();
                    },
                    response => {
                        this.errors = response.data;
                        this.successAdd = false;
                    }
                );
            };

            this.onCancel = () => {
                goToReturnState();
            }

        }
    });

export default usersPageAddModule.name;




// WEBPACK FOOTER //
// ./src/cmsPages/Users/UsersAddPageDirective.js